import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import cn from '../utils/cn';
import styles from './Tooltip.module.css';

const GAP = 8;

function computeCoords(rect, placement) {
  switch (placement) {
    case 'bottom':
      return { top: rect.bottom + GAP, left: rect.left + rect.width / 2 };
    case 'left':
      return { top: rect.top + rect.height / 2, left: rect.left - GAP };
    case 'right':
      return { top: rect.top + rect.height / 2, left: rect.right + GAP };
    default:
      return { top: rect.top - GAP, left: rect.left + rect.width / 2 };
  }
}

const Tooltip = React.forwardRef(function Tooltip(
  { title, placement = 'top', className, children, ...rest },
  ref
) {
  const [coords, setCoords] = useState(null);
  const hasTitle = title !== null && title !== undefined && title !== '';

  const show = e =>
    setCoords(
      computeCoords(e.currentTarget.getBoundingClientRect(), placement)
    );
  const hide = () => setCoords(null);

  return (
    <span
      ref={ref}
      className={cn(styles.root, className)}
      {...rest}
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}>
      {children}
      {hasTitle &&
        coords &&
        ReactDOM.createPortal(
          <span
            role='tooltip'
            className={cn(styles.bubble, styles[placement])}
            style={{ top: coords.top, left: coords.left }}>
            <span className={styles.arrow} />
            <span className={styles.inner}>{title}</span>
          </span>,
          document.body
        )}
    </span>
  );
});

Tooltip.propTypes = {
  title: PropTypes.node,
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  className: PropTypes.string,
  children: PropTypes.node
};

export default Tooltip;
